import { useParams } from 'react-router-dom';
import { useOverseasRealEstateSymbolPage } from './hooks';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { OverseasRealEstateSymbolDetail } from './symbolDetail';
import { OverseasRealEstateSymbolApplyComplete } from './symbolApplyComplete';
import { useEffect } from 'react';
import { NotFoundData } from 'views/mutual/notFoundData';
import { SymbolPageStep } from './hooks';
import { CompatibilityCheck } from 'views/pages/compatibilityCheck';
import { ProductType } from 'constants/productType';
import { ApplicationStatusWrapper } from '../module/applicationStatus';
import { OverseasRealEstateSymbolApplyConfirm } from './symbolApplyConfirm';
import { OverseasRealEstateFatcaWrapper } from './fatca';
import { OverseasRealEstateContractProcedure } from 'views/pages/contractProcedure/overseasRealEstate';
import { ContractProcedureStep } from 'views/pages/contractProcedure/overseasRealEstate/hooks';

export const OverseasRealEstateSymbol = () => {
  const { symbol } = useParams<{ symbol: string }>();

  const {
    symbolPageStep,
    symbolDetailInfo,
    applySymbolRes,
    confirmApplySymbolRes,
    formik,
    canApplySymbol,
    interest,
    amountRaw,
    totalAmountRaw,
    transferDateProps,
    checkContractDocumentProps,
    backDetailPage,
    amountProps,
  } = useOverseasRealEstateSymbolPage({ symbol: symbol! });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [symbolPageStep]);

  if (symbolDetailInfo.fetching) {
    return (
      <LoadingContainer isLoading={symbolDetailInfo.fetching} size={LoadingSize.Medium}>
        <div></div>
      </LoadingContainer>
    );
  } else {
    if (!symbolDetailInfo.data?.GetOverseasRealEstateSymbolInfo) {
      return (
        <NotFoundData
          backPageType={{
            kind: 'previous',
          }}
        />
      );
    }

    //TODO: GetOverseasSymbolを作成したら戻す
    switch (symbolPageStep) {
      case SymbolPageStep.Detail:
        return (
          <OverseasRealEstateSymbolDetail
            symbolDetail={symbolDetailInfo.data?.GetOverseasRealEstateSymbolInfo}
            formik={formik}
            interest={interest}
            amountRaw={amountRaw}
            totalAmountRaw={totalAmountRaw}
            canApplySymbol={canApplySymbol}
            transferDateProps={transferDateProps}
            checkContractDocumentProps={checkContractDocumentProps}
            amountProps={amountProps}
          />
        );
      case SymbolPageStep.CompatibilityCheck:
        return (
          <CompatibilityCheck
            assetType={ProductType.OverseasRealEstate}
            completedNextPage={{
              label: '申込内容確認に進む',
              navigate: formik.handleSubmit,
            }}
          />
        );
      case SymbolPageStep.ApplicationStatus:
        return (
          <OverseasRealEstateFatcaWrapper navigate={formik.handleSubmit}/>
        );
      case SymbolPageStep.Confirm:
        return (
          <OverseasRealEstateSymbolApplyConfirm
            symbolDetail={symbolDetailInfo.data?.GetOverseasRealEstateSymbolInfo}
            formik={formik}
            applySymbolRes={confirmApplySymbolRes?.data?.ApplySymbol}
            amountRaw={amountRaw}
            totalAmountRaw={totalAmountRaw}
            interest={interest}
            backDetailPage={backDetailPage}
          />
        );
      case SymbolPageStep.Complete:
        return <OverseasRealEstateSymbolApplyComplete />;
      case SymbolPageStep.ContractComplete:
        return (
          <OverseasRealEstateContractProcedure
            applicationID={applySymbolRes?.data?.ApplySymbol?.ID!}
            defaultContractProcedureStep={ContractProcedureStep.Complete}
          />
        );
    }
  }
};
